export default __webpack_public_path__ + "media/images/mailer/logo-1f2f2241f1d076df46f96cac98e23603.png";